import React, { useState } from "react";
import { post } from "../../utils/api";
import apiServer from "../../constants/apiServer";
import { useNavigate } from "react-router-dom";
import AdaAlert from "../../common/AdaAlert";
import OperatorForm from "./OperatorForm";
import { checkFormValidate } from "../../utils/commonFuncs";
import PopupLoading from "../../common/PopupLoading";
import { handleApiError, handleApiSuccess } from "../../utils/errorHandler";
const CreateOperator = () => {
  const navigate = useNavigate();

  const [operatorInfoValues, setOperatorInfoValues] = useState({
    email: "",
    password: "",
    name: "",
    phone: "",
    showPassword: false,
    role_id: 1, // default role
    status: 1 // default active status
  });

  const [errorValues, setErrorValues] = useState({});
  const [createOperatorLoading, setCreateOperatorLoading ] = useState(false);
  const [errorCreate, setErrorCreate] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { email, password, name, phone, role_id, status } = operatorInfoValues;
    const checkGeneralInfo = checkFormValidate({
      email,
      password,
      name,
      phone,
    });
    setErrorValues(checkGeneralInfo);
    const errorStateList = Object.keys(checkGeneralInfo);
    
    if (errorStateList.length === 0 && email.length < 200 && password.length < 200) {
      setCreateOperatorLoading(true);

      const fd = new FormData();
      fd.append("name", name);
      fd.append("phone", phone);
      fd.append("email", email);
      fd.append("password", password);
      fd.append("role_id", role_id);
      fd.append("status", status);

      const createOperatorURL = `${apiServer.operator.create}`;
      
      try {
        const response = await post(createOperatorURL, fd);
        const responseData = handleApiSuccess(response, setCreateOperatorLoading);
        
        navigate("/operators", { 
          replace: true, 
          state: { status: 'success', message: responseData.message } 
        });
      } catch (errors) {
        handleApiError(errors, setErrorCreate, setCreateOperatorLoading);
      }
    }
  };

  const handleChangeValue = (event) => {
    const { name, value } = event.target;
    setOperatorInfoValues((operatorInfo) => {
      return {
        ...operatorInfo,
        [name]: value
      };
    });
  };

  const handleChangePasswordType = () => {
    setOperatorInfoValues((operatorInfo) => {
      return {
        ...operatorInfo,
        showPassword: !operatorInfo["showPassword"]
      };
    });
  };

  const handleCancel = () => {
    navigate("/operators", { replace: true });
  };

  if(createOperatorLoading) return <PopupLoading text="Creating Opreator"/>

  return (
    <>
      <OperatorForm
        onCreate={handleSubmit}
        onCancel={handleCancel}
        formTitle="Create Operator"
        onSubmitName="Create"
        onChangeValue={handleChangeValue}
        infoValues={operatorInfoValues}
        errorValue={errorValues}
        onShowPassword={handleChangePasswordType}
      />
      {errorCreate !== "" && <AdaAlert type="error" message={errorCreate} />}
    </>
  );
};

export default CreateOperator;
